export default __webpack_public_path__ + "static/media/img-feedback-status.862ad252.svg";